import React, { useState, useRef, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import { RecordVoiceOver, VoiceOverOff, Audiotrack, MusicOff } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const VoiceToggle = ({ setVoiceToggle }) => {
    const [isPlaying, setIsPlaying] = useState(false); // Default isPlaying to true for autoplay

    const togglePlayPause = () => {
        const prevValue = isPlaying;
        setIsPlaying(!prevValue);
        setVoiceToggle(!prevValue);
    };



    return (
        <Tooltip title="Text to Speech">
        <IconButton onClick={togglePlayPause} id='voiceToggle'>
            {isPlaying ? <RecordVoiceOver /> : <VoiceOverOff />}
        </IconButton>
        </Tooltip>
    );
};

export default VoiceToggle;
